import { FC, useEffect } from "react";
import { ClientProps } from "../../hooks/useClientData";
import { brand } from "../../brandVariables/getBandVariables";
import "./styles/index.scss";
import { useTimer } from "../../hooks/useCountDown";
import { setCurrentChallengeToOnGoing } from "@/helperFunctions/setCurrentChallengeToOnGoing";
import { BrandLogo } from "../reusable/brandLogo";
import { RacingCountdown } from "./components/Racing_countdown";
import { RacingWaitingScreenWinners } from "./components/Racing_waitingScreen.winners";

export const RACINGWaitingScreen: FC<{
  clientData: ClientProps;
}> = ({ clientData }) => {
  const { time, timeObj, isTimeOver } = useTimer(
    clientData.nextChallenges?.data?.[0]?.startDate || undefined
  );
  const isElgiganten = brand.client === "elgiganten-9u2oj" ? "text-gradient" : "";

  useEffect(() => {
    let hasRan;

    if (
      !clientData.challenge.data &&
      !hasRan &&
      !clientData.nextChallenges.loading &&
      clientData.nextChallenges.data?.[0] &&
      isTimeOver
    ) {
      hasRan = true;

      setCurrentChallengeToOnGoing(clientData.nextChallenges.data?.[0].slug);
    }
  }, [time, isTimeOver]);

  return (
    <>
      <div className="waiting-screen">
        <section>
          <div className="waiting-screen__countdown">
            <div className="waiting-screen__heading">
              <div className="brand-logo">
                <BrandLogo />
              </div>
            </div>
            <h2>New challenge in</h2>
            {RacingCountdown({ timeObj })}

            {brand.prize && (
              <h3>
                {brand.prize.content}{" "}
                <span className={`${isElgiganten}`}>{brand.prize.nameOf}</span>{" "}
              </h3>
            )}
          </div>
        </section>

        {RacingWaitingScreenWinners(clientData)}
      </div>
    </>
  );
};
